<!-- Единый блок неизменяемого текста подтверждения и рукописной подписи. -->
<template>
  <div class="vehicle-inspection-signature-field">
    <div class="vehicle-inspection-signature-field__statement">
      <span class="vehicle-inspection-signature-field__label">Подписываемый текст</span>
      <p>{{ statement }}</p>
    </div>
    <BaseSignaturePad ref="pad" @change="$emit('change', $event)" />
  </div>
</template>

<script>
export default {
  name: "VehicleInspectionSignatureField",

  props: {
    statement: {
      type: String,
      required: true,
    },
  },

  emits: ["change"],

  methods: {
    getBlob() {
      return this.$refs.pad.getBlob();
    },
  },
};
</script>

<style scoped>
.vehicle-inspection-signature-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.vehicle-inspection-signature-field__statement {
  padding: 14px 16px;
  border: 1px solid var(--color-grey);
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  background: color-mix(in srgb, var(--color-green) 5%, var(--color-light));
}

.vehicle-inspection-signature-field__label {
  display: block;
  margin-bottom: 6px;
  color: color-mix(in srgb, var(--color-dark) 65%, var(--color-light));
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
}

.vehicle-inspection-signature-field__statement p {
  margin: 0;
  color: var(--color-dark);
  font-size: 14px;
  line-height: 1.5;
}

.vehicle-inspection-signature-field :deep(.base-signature-pad__canvas) {
  border-radius: 0 0 10px 10px;
}
</style>
